import React from 'react'

import { Heading, Button } from '@/components'

const InstanceSettingsPageScorm = ({ onGenerateScormPackage, isLoading }) => {
  return (
    <div className="InstanceSettingsPage__setting InstanceSettingsPage__scorm">
      <Heading is4 className="InstanceSettingsPage__scorm-title">
        SCORM Settings
      </Heading>

      <Button
        className="InstanceSettingsPage__scorm-button"
        isLoading={isLoading}
        onClick={onGenerateScormPackage}
      >
        Download Course SCORM Package
      </Button>
    </div>
  )
}

export default InstanceSettingsPageScorm
